 

class Falta {  
 
    public static campos = () => {
        return [   
            {
                nome: "observacaoste",
                type: "text",
                label: "Observação STE",
                sm: 12 ,
                lg: 12, 
                disabled: false
            },   
            
        ];
    }   
}
  
export   {  Falta };
